import { Button } from "@/components/buttons/Button";
import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { INiche } from "@/common/services/types";
import { NichePreviewClickInitiator } from "@/common/buses";
import ChevronIcon from "@/common/images/icons/chevron.svg?react";
import "./NichePreviewButton.scss";

interface IProps {
  niche: INiche;
  withWatchButton?: boolean;
  onPreviewClick: (initiator: NichePreviewClickInitiator) => void;
}

export const NichePreviewButton = ({ niche, withWatchButton = true, onPreviewClick }: IProps) => {
  const navigate = useNavigate();

  const onOpenNiche = (initiator: NichePreviewClickInitiator) => () => {
    onPreviewClick(initiator);

    navigate(routes.niche(niche.id));
  };

  const renderActionButton = () => {
    if (withWatchButton) {
      return (
        <Button variant="primary" size="xs" onClick={onOpenNiche("watch button")}>
         Watch
        </Button>
      );
    }

    return (
      <Button variant="secondary" round size="xs" onClick={onOpenNiche("arrow button")}>
        <ChevronIcon />
      </Button>
    );
  };

  return (
    <div className="NichePreviewButton">
      {renderActionButton()}
    </div>
  );
};
